<template>
    <label :for="name" v-if="label" class="input-label">{{ label }} <span class="field-mandatory" v-if="required">(* {{ t.mandatory }})</span></label>
    <input
        class="styled-input"
        :id="name"
        :type="type"
        :value="modelValue"
        @input="updateValue"
        :placeholder="computedPlaceholder"
        :minlength="minLength"
        :maxlength="maxLength"
        :pattern="pattern"
        :required="required"
    />
</template>

<script>
import { computed, watch, ref } from 'vue';
import useTexts from "@/composables/useTexts";

export default {
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: ''
    },
    minLength: {
      type: Number,
      default: 0
    },
    maxLength: {
      type: Number,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    pattern: {
      type: String,
      default: null
    },
  },
  setup(props, { emit }) {
    const computedPlaceholder = computed(() => props.placeholder || props.label);
    const isFilledIn = ref(!!props.modelValue);
    const { getTextsForComponent } = useTexts();
    const t = getTextsForComponent('InputText')

    const updateValue = (event) => {
      emit('update:modelValue', event.target.value);
      isFilledIn.value = !!event.target.value;
    };

    // emit an event whenever the filled in state changes
    watch(isFilledIn, (newValue) => {
      emit('update:filledIn', newValue);
    });

    // setup a watcher to the modelValue, so isFilledIn stays synced
    watch(() => props.modelValue, (newValue) => {
      isFilledIn.value = !!newValue;
    });

    return {
      updateValue,
      computedPlaceholder,
      isFilledIn,
      t
    };
  }
}
</script>


<style scoped>

.styled-input {
  width: 100%;
  border: 1px solid #e9e9e9;
  font-size: 1em;
  outline: none;
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 7px 10px;
}

.styled-input:focus {
  outline: auto 2px Highlight; /* Default focus style for most browsers */
  outline: 5px auto -webkit-focus-ring-color; /* Default focus style for Safari */
}

.input-label {
  font-weight: bold;
}
.field-mandatory {
  font-size: 0.8em;
  font-style: italic;
}
</style>
